import { useState, useCallback, useEffect, useRef } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import CanvasMeasure from "../components/CanvasMeasure";

// ── Palette YOMA ──────────────────────────────────────────────────────────────
const GOLD   = "#C9A96E";
const INK    = "#1C1915";
const WARM   = "#F8F4EE";
const BORDER = "#E7E1D8";
const MUTED  = "#8B7361";
const WHITE  = "#FFFFFF";
const SOFT   = "#F2EDE6";

// ── Devises ───────────────────────────────────────────────────────────────────
const CURRENCIES = [
  { code: "MAD", symbol: "MAD" },
  { code: "EUR", symbol: "€"  },
  { code: "USD", symbol: "$"  },
  { code: "GBP", symbol: "£"  },
  { code: "CHF", symbol: "CHF"},
];

// ── Données par défaut (issues du FEUILLE DE CALCUL.xlsx) ────────────────────
const DEFAULT_LOTS = [
  {
    id: "GO", label: "LOT 01 — Gros Œuvre", icon: "🏗", color: "#8B5E3C",
    sous_lots: [
      {
        id: "maconnerie", label: "Maçonnerie",
        items: [
          { id: "go-1",  designation: "Agglos 15×20×40",          unite: "U",      quantite: 0, prixU: 5.50,   marge: 15 },
          { id: "go-2",  designation: "Mortier de maçonnerie",     unite: "m³",     quantite: 0, prixU: 670,    marge: 15 },
          { id: "go-3",  designation: "Mortier façade",            unite: "m²",     quantite: 0, prixU: 28.34,  marge: 15 },
          { id: "go-4",  designation: "Poteau béton 15×15",        unite: "ml",     quantite: 0, prixU: 38.96,  marge: 15 },
          { id: "go-5",  designation: "Poteau béton 20×20",        unite: "ml",     quantite: 0, prixU: 155.82, marge: 15 },
          { id: "go-6",  designation: "Poteau béton 30×30",        unite: "ml",     quantite: 0, prixU: 69.25,  marge: 15 },
          { id: "go-7",  designation: "Linteau béton 15×15",       unite: "ml",     quantite: 0, prixU: 38.06,  marge: 15 },
          { id: "go-8",  designation: "Poutre béton 20×20",        unite: "ml",     quantite: 0, prixU: 78.85,  marge: 15 },
          { id: "go-9",  designation: "Chaînage béton 15×10",      unite: "ml",     quantite: 0, prixU: 22.37,  marge: 15 },
        ]
      },
      {
        id: "dalle", label: "Dalle & Planchers",
        items: [
          { id: "da-1", designation: "Plancher préfabriqué",       unite: "m²",     quantite: 0, prixU: 193.42, marge: 15 },
          { id: "da-2", designation: "Dalle béton armé",           unite: "m²",     quantite: 0, prixU: 76.06,  marge: 15 },
          { id: "da-3", designation: "Escalier béton",             unite: "U",      quantite: 0, prixU: 321.41, marge: 15 },
          { id: "da-4", designation: "Palier d'escalier",          unite: "m²",     quantite: 0, prixU: 193.42, marge: 15 },
        ]
      },
      {
        id: "menuiseries-ext", label: "Menuiseries Extérieures",
        items: [
          { id: "me-1", designation: "Fenêtre DV aluminium 120×125", unite: "U",   quantite: 0, prixU: 1771,   marge: 20 },
          { id: "me-2", designation: "Porte d'entrée blindée",      unite: "U",    quantite: 0, prixU: 2800,   marge: 20 },
          { id: "me-3", designation: "Porte service / magasin",     unite: "U",    quantite: 0, prixU: 1800,   marge: 20 },
        ]
      }
    ]
  },
  {
    id: "SO", label: "LOT 02 — Second Œuvre", icon: "🔧", color: "#3A5A6E",
    sous_lots: [
      {
        id: "doublage", label: "Doublage Placo",
        items: [
          { id: "do-1", designation: "BA13 doublage",              unite: "m²",    quantite: 0, prixU: 31.25,  marge: 20 },
          { id: "do-2", designation: "Montant M48",                unite: "ml",    quantite: 0, prixU: 11.76,  marge: 20 },
          { id: "do-3", designation: "Rail R48",                   unite: "ml",    quantite: 0, prixU: 10.80,  marge: 20 },
          { id: "do-4", designation: "Laine de verre (isolation)", unite: "m²",    quantite: 0, prixU: 26.40,  marge: 20 },
        ]
      },
      {
        id: "cloison", label: "Cloisons Placo",
        items: [
          { id: "cl-1", designation: "BA13 cloison standard",      unite: "m²",    quantite: 0, prixU: 31.25,  marge: 20 },
          { id: "cl-2", designation: "BA13 marine (zones humides)",unite: "m²",    quantite: 0, prixU: 38.50,  marge: 20 },
          { id: "cl-3", designation: "Montant M48 cloison",        unite: "ml",    quantite: 0, prixU: 11.76,  marge: 20 },
          { id: "cl-4", designation: "Rail R48 cloison",           unite: "ml",    quantite: 0, prixU: 10.80,  marge: 20 },
        ]
      },
      {
        id: "plafond", label: "Faux-Plafonds",
        items: [
          { id: "fp-1", designation: "BA13 faux-plafond",          unite: "m²",    quantite: 0, prixU: 31.25,  marge: 20 },
          { id: "fp-2", designation: "Montant M48 plafond",        unite: "ml",    quantite: 0, prixU: 11.76,  marge: 20 },
          { id: "fp-3", designation: "Rail R48 plafond",           unite: "ml",    quantite: 0, prixU: 10.80,  marge: 20 },
        ]
      },
      {
        id: "electricite", label: "Électricité",
        items: [
          { id: "el-1", designation: "Tableau électrique général", unite: "Forfait",quantite: 0, prixU: 2500,   marge: 20 },
          { id: "el-2", designation: "Prise de courant 16A",       unite: "U",      quantite: 0, prixU: 120,    marge: 20 },
          { id: "el-3", designation: "Interrupteur simple",        unite: "U",      quantite: 0, prixU: 80,     marge: 20 },
          { id: "el-4", designation: "Point lumineux complet",     unite: "U",      quantite: 0, prixU: 180,    marge: 20 },
          { id: "el-5", designation: "Câble électrique 2.5mm²",   unite: "ml",     quantite: 0, prixU: 12,     marge: 20 },
          { id: "el-6", designation: "Spot encastré LED",          unite: "U",      quantite: 0, prixU: 95,     marge: 20 },
        ]
      },
      {
        id: "plomberie", label: "Plomberie",
        items: [
          { id: "pl-1", designation: "Alimentation eau froide",    unite: "ml",    quantite: 0, prixU: 55,     marge: 20 },
          { id: "pl-2", designation: "Alimentation eau chaude",    unite: "ml",    quantite: 0, prixU: 65,     marge: 20 },
          { id: "pl-3", designation: "Évacuation PVC Ø100",        unite: "ml",    quantite: 0, prixU: 45,     marge: 20 },
          { id: "pl-4", designation: "WC suspendu complet",        unite: "U",     quantite: 0, prixU: 1800,   marge: 20 },
          { id: "pl-5", designation: "Receveur douche",            unite: "U",     quantite: 0, prixU: 1200,   marge: 20 },
          { id: "pl-6", designation: "Chauffe-eau 150L",           unite: "U",     quantite: 0, prixU: 2200,   marge: 20 },
          { id: "pl-7", designation: "Lavabo à poser",             unite: "U",     quantite: 0, prixU: 650,    marge: 20 },
        ]
      }
    ]
  },
  {
    id: "FIN", label: "LOT 03 — Finitions", icon: "✨", color: "#5A3D7E",
    sous_lots: [
      {
        id: "revetements", label: "Carrelage & Revêtements",
        items: [
          { id: "re-1", designation: "Carrelage sol 60×60",        unite: "m²",    quantite: 0, prixU: 150,    marge: 25 },
          { id: "re-2", designation: "Tadelakt / Béton ciré",      unite: "m²",    quantite: 0, prixU: 123,    marge: 25 },
          { id: "re-3", designation: "Carrelage mur salle de bain",unite: "m²",    quantite: 0, prixU: 120,    marge: 25 },
          { id: "re-4", designation: "Plinthe carrelage",          unite: "ml",    quantite: 0, prixU: 35,     marge: 25 },
          { id: "re-5", designation: "Parquet stratifié / contrecollé",unite: "m²",quantite: 0, prixU: 95,    marge: 25 },
        ]
      },
      {
        id: "peintures", label: "Peintures & Enduits",
        items: [
          { id: "pe-1", designation: "Enduit intérieur mortier",   unite: "m²",    quantite: 0, prixU: 28.34,  marge: 25 },
          { id: "pe-2", designation: "Peinture intérieure 2 couches",unite:"m²",   quantite: 0, prixU: 45,     marge: 25 },
          { id: "pe-3", designation: "Peinture plafond",           unite: "m²",    quantite: 0, prixU: 38,     marge: 25 },
          { id: "pe-4", designation: "Peinture façade",            unite: "m²",    quantite: 0, prixU: 52,     marge: 25 },
        ]
      },
      {
        id: "menuiseries-int", label: "Menuiseries Intérieures",
        items: [
          { id: "mi-1", designation: "Porte intérieure 90×210",    unite: "U",     quantite: 0, prixU: 1200,   marge: 25 },
          { id: "mi-2", designation: "Placard sur mesure",         unite: "ml",    quantite: 0, prixU: 850,    marge: 25 },
          { id: "mi-3", designation: "Dressing sur mesure",        unite: "m²",    quantite: 0, prixU: 1200,   marge: 25 },
          { id: "mi-4", designation: "Cuisine équipée",            unite: "Forfait",quantite: 0, prixU: 25000, marge: 25 },
        ]
      }
    ]
  }
];

// ── Calculs ───────────────────────────────────────────────────────────────────
function calcRow(item) {
  const qte    = Number(item.quantite) || 0;
  const pu     = Number(item.prixU)    || 0;
  const marge  = Number(item.marge)    || 0;
  const ht     = qte * pu;
  const client = ht * (1 + marge / 100); // prix client (HT + marge archi)
  const margeAmt = client - ht;
  return { ht, client, margeAmt, qte, pu, marge };
}

function lotTotals(lot) {
  let ht = 0, client = 0, margeAmt = 0;
  lot.sous_lots.forEach(sl => sl.items.forEach(it => {
    const c = calcRow(it);
    ht += c.ht; client += c.client; margeAmt += c.margeAmt;
  }));
  return { ht, client, margeAmt };
}

function fmtN(n, sym = "MAD") {
  return Math.round(Number(n) || 0).toLocaleString("fr-FR") + " " + sym;
}
function fmtDec(n) {
  return (Number(n) || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// ── IDs utils ─────────────────────────────────────────────────────────────────
let _id = 1000;
function uid() { return `item-${++_id}-${Date.now()}`; }

// ═══════════════════════════════════════════════════════════════════════════════
export default function EstimatorPage() {
  const [project,   setProject]   = useState({ name: "", client: "", surface: "", adresse: "" });
  const [currency,  setCurrency]  = useState("MAD");
  const [tva,       setTva]       = useState(20);
  const [lots,      setLots]      = useState(() => JSON.parse(JSON.stringify(DEFAULT_LOTS)));
  const [openLots,  setOpenLots]  = useState({ GO: true, SO: false, FIN: false });
  const [openSLots, setOpenSLots] = useState({});
  const [showCanvas, setShowCanvas] = useState(false);
  const [pending,   setPending]   = useState(null); // measure waiting to be injected
  const [injectRow, setInjectRow] = useState(null); // row id targeted
  const [showMarges,  setShowMarges]  = useState(true);
  const [autoFilled,  setAutoFilled]  = useState(false);
  const sym = CURRENCIES.find(c => c.code === currency)?.symbol || currency;

  // ── Item helpers ────────────────────────────────────────────────────────
  function updateItem(lotId, slId, itemId, field, value) {
    setLots(prev => prev.map(l => l.id !== lotId ? l : {
      ...l, sous_lots: l.sous_lots.map(sl => sl.id !== slId ? sl : {
        ...sl, items: sl.items.map(it => it.id !== itemId ? it : { ...it, [field]: value })
      })
    }));
  }
  function addItem(lotId, slId) {
    const it = { id: uid(), designation: "Nouveau poste", unite: "m²", quantite: 0, prixU: 0, marge: 20 };
    setLots(prev => prev.map(l => l.id !== lotId ? l : {
      ...l, sous_lots: l.sous_lots.map(sl => sl.id !== slId ? sl : { ...sl, items: [...sl.items, it] })
    }));
  }
  function delItem(lotId, slId, itemId) {
    setLots(prev => prev.map(l => l.id !== lotId ? l : {
      ...l, sous_lots: l.sous_lots.map(sl => sl.id !== slId ? sl : { ...sl, items: sl.items.filter(i => i.id !== itemId) })
    }));
  }
  function injectMeasure(lotId, slId, itemId, value) {
    updateItem(lotId, slId, itemId, "quantite", value);
    setPending(null);
    setInjectRow(null);
  }

  // ── Auto-fill depuis les mesures canvas ─────────────────────────────────
  function autoFillFromMeasures({ levels, buildingParams: _bp }) {
    const r1 = n => Math.round(n * 10) / 10;

    // Agréger surface & périmètre par niveau
    let totSurface = 0, totPerimetre = 0, totWalls = 0;
    levels.forEach(lvl => {
      const poly = lvl.done.filter(m => m.type === "polygon").reduce((s, m) => s + m.value, 0);
      const surf = poly > 0 ? poly : parseFloat(lvl.manualSurface) || 0;
      const lin  = lvl.done.filter(m => m.type === "line").reduce((s, m) => s + m.value, 0);
      const peri = lin > 0 ? lin : (parseFloat(lvl.manualPerimetre) || (surf > 0 ? 4 * Math.sqrt(surf) : 0));
      const hsp  = parseFloat(lvl.hsp) || 2.8;
      totSurface   += surf;
      totPerimetre += peri;
      totWalls     += peri * hsp;
    });
    if (totSurface === 0 && totPerimetre === 0) return;
    const nbNiv = levels.length;

    // Table de correspondance id-item → quantité calculée
    const updates = {
      // LOT 01 — Gros Œuvre
      "go-2": r1(totWalls * 0.20),          // Mortier maçonnerie m³
      "go-3": r1(totWalls),                  // Mortier façade m²
      "go-8": r1(totPerimetre * 0.5),        // Poutre béton ml
      "da-1": r1(totSurface),                // Plancher préfabriqué m²
      "da-2": r1(totSurface),                // Dalle béton armé m²
      "da-3": Math.max(0, nbNiv - 1),        // Escalier béton U
      "me-1": Math.ceil(totPerimetre / 10),  // Fenêtres DV U
      // LOT 02 — Second Œuvre
      "do-1": r1(totWalls * 0.5),            // BA13 doublage m²
      "do-4": r1(totWalls * 0.5),            // Laine de verre m²
      "cl-1": r1(totSurface * 0.35),         // BA13 cloison standard m²
      "fp-1": r1(totSurface),                // BA13 faux-plafond m²
      "el-2": Math.ceil(totSurface / 5),     // Prises 16A U
      "el-4": Math.ceil(totSurface / 8),     // Points lumineux U
      "el-5": Math.round(totSurface * 3),    // Câble 2.5mm² ml
      "pl-1": Math.round(totPerimetre * 0.6),// Alim EF ml
      "pl-3": Math.round(totPerimetre * 0.4),// Évacuation PVC ml
      // LOT 03 — Finitions
      "re-1": r1(totSurface),                // Carrelage sol m²
      "re-4": r1(totPerimetre),              // Plinthe ml
      "pe-1": r1(totWalls * 0.85),           // Enduit intérieur m²
      "pe-2": r1(totWalls * 0.85 + totSurface), // Peinture intérieure m²
      "pe-3": r1(totSurface),                // Peinture plafond m²
      "mi-1": Math.ceil(totSurface / 12),    // Portes intérieures U
    };

    setLots(prev => prev.map(lot => ({
      ...lot,
      sous_lots: lot.sous_lots.map(sl => ({
        ...sl,
        items: sl.items.map(item =>
          updates[item.id] !== undefined
            ? { ...item, quantite: updates[item.id], _auto: true }
            : item
        ),
      })),
    })));
    setAutoFilled(true);
    setOpenLots({ GO: true, SO: true, FIN: true }); // tout déplier pour montrer les résultats
  }

  // ── Totaux globaux ──────────────────────────────────────────────────────
  const globalHT     = lots.reduce((s, l) => s + lotTotals(l).ht, 0);
  const globalClient = lots.reduce((s, l) => s + lotTotals(l).client, 0);
  const globalMarge  = lots.reduce((s, l) => s + lotTotals(l).margeAmt, 0);
  const globalTTC    = globalClient * (1 + tva / 100);

  // ── PDF Export ──────────────────────────────────────────────────────────
  function exportPDF() {
    const doc  = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    const W    = doc.internal.pageSize.getWidth();
    const H    = doc.internal.pageSize.getHeight();
    const today = new Date().toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" });

    // ── GARDE ──
    doc.setFillColor(28, 25, 21); doc.rect(0, 0, W, H, "F");
    doc.setDrawColor(201, 169, 110); doc.setLineWidth(0.5);
    doc.line(14, 50, W - 14, 50); doc.line(14, H - 50, W - 14, H - 50);

    doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(201, 169, 110);
    doc.text("YOMA DESIGN · ARCHITECTURE INTÉRIEURE & COORDINATION", W / 2, 43, { align: "center" });

    doc.setFont("helvetica", "bold"); doc.setFontSize(34); doc.setTextColor(255, 255, 255);
    doc.text("ESTIMATIF TRAVAUX", W / 2, 92, { align: "center" });
    doc.setFont("helvetica", "normal"); doc.setFontSize(13); doc.setTextColor(201, 169, 110);
    doc.text("Métré · Devis · Dossier de Coordination", W / 2, 103, { align: "center" });

    if (project.name) {
      doc.setFontSize(18); doc.setFont("helvetica", "bold"); doc.setTextColor(255, 255, 255);
      doc.text(project.name.toUpperCase(), W / 2, 132, { align: "center" });
    }
    if (project.client) {
      doc.setFontSize(11); doc.setFont("helvetica", "normal"); doc.setTextColor(150, 140, 130);
      doc.text(`Client · ${project.client}`, W / 2, 142, { align: "center" });
    }
    if (project.surface) {
      doc.setFontSize(10); doc.setTextColor(120, 110, 100);
      doc.text(`Surface : ${project.surface} m² · ${project.adresse || ""}`, W / 2, 151, { align: "center" });
    }

    // Budget box
    doc.setFillColor(38, 34, 30); doc.roundedRect(20, H - 95, W - 40, 42, 4, 4, "F");
    doc.setTextColor(201, 169, 110); doc.setFontSize(9);
    doc.text("BUDGET TOTAL TRAVAUX (CLIENT)", W / 2, H - 83, { align: "center" });
    doc.setFont("helvetica", "bold"); doc.setFontSize(26); doc.setTextColor(255, 255, 255);
    doc.text(`${fmtDec(globalClient)} ${sym}`, W / 2, H - 68, { align: "center" });
    doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(120, 110, 100);
    doc.text(`Base HT : ${fmtDec(globalHT)} ${sym}  ·  Honoraires YOMA inclus  ·  Hors TVA`, W / 2, H - 60, { align: "center" });

    doc.setFontSize(8); doc.setTextColor(80, 70, 60);
    doc.text(today, W / 2, H - 44, { align: "center" });

    // ── UNE PAGE PAR LOT ──
    lots.forEach(lot => {
      const lt = lotTotals(lot);
      if (lt.client === 0) return;
      doc.addPage();

      // Header
      doc.setFillColor(248, 244, 238); doc.rect(0, 0, W, 30, "F");
      doc.setDrawColor(201, 169, 110); doc.setLineWidth(0.8); doc.line(0, 30, W, 30);
      doc.setFont("helvetica", "bold"); doc.setFontSize(16); doc.setTextColor(28, 25, 21);
      doc.text(lot.label.toUpperCase(), 14, 18);
      doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(139, 115, 97);
      doc.text(`Total client : ${fmtDec(lt.client)} ${sym}`, W - 14, 18, { align: "right" });

      let y = 36;
      lot.sous_lots.forEach(sl => {
        const rows = sl.items.filter(it => Number(it.quantite) > 0).map(it => {
          const c = calcRow(it);
          const row = [it.designation, it.unite, fmtDec(c.qte), fmtDec(c.pu), `${fmtDec(c.ht)} ${sym}`];
          if (showMarges) row.push(`${it.marge}%`, `${fmtDec(c.client)} ${sym}`);
          return row;
        });
        if (rows.length === 0) return;

        const head = ["Désignation", "Unité", "Qté", "P.U.", "Total HT"];
        if (showMarges) head.push("Marge", "Total Client");

        doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.setTextColor(28, 25, 21);
        doc.text(sl.label.toUpperCase(), 14, y + 5); y += 8;

        doc.autoTable({
          startY: y, head: [head], body: rows, theme: "grid",
          headStyles: { fillColor: [28, 25, 21], textColor: [201, 169, 110], fontStyle: "bold", fontSize: 8 },
          bodyStyles: { fontSize: 8, textColor: [40, 35, 30] },
          alternateRowStyles: { fillColor: [252, 249, 245] },
          columnStyles: {
            2: { halign: "right" }, 3: { halign: "right" }, 4: { halign: "right", fontStyle: "bold" },
            ...(showMarges ? { 5: { halign: "center" }, 6: { halign: "right", fontStyle: "bold" } } : {})
          },
          margin: { left: 14, right: 14 },
        });
        y = doc.lastAutoTable.finalY + 6;
      });

      // Sous-total lot
      doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.setTextColor(28, 25, 21);
      doc.text(`Sous-total ${lot.label} : ${fmtDec(lt.client)} ${sym}`, W - 14, y + 6, { align: "right" });

      // Footer
      doc.setFont("helvetica", "normal"); doc.setFontSize(7); doc.setTextColor(170, 160, 150);
      doc.text("YOMA DESIGN · Estimatif Travaux · Document confidentiel", 14, H - 6);
      doc.text(today, W - 14, H - 6, { align: "right" });
    });

    // ── PAGE RÉCAP ──
    doc.addPage();
    doc.setFillColor(28, 25, 21); doc.rect(0, 0, W, 32, "F");
    doc.setFont("helvetica", "bold"); doc.setFontSize(16); doc.setTextColor(201, 169, 110);
    doc.text("RÉCAPITULATIF FINANCIER", 14, 20);

    const recapRows = lots.map(lot => {
      const lt = lotTotals(lot);
      return [lot.label, `${fmtDec(lt.ht)} ${sym}`, showMarges ? `${fmtDec(lt.margeAmt)} ${sym}` : "", `${fmtDec(lt.client)} ${sym}`];
    });
    recapRows.push(["TOTAL GÉNÉRAL", `${fmtDec(globalHT)} ${sym}`, showMarges ? `${fmtDec(globalMarge)} ${sym}` : "", `${fmtDec(globalClient)} ${sym}`]);
    if (tva > 0) recapRows.push([`TTC avec TVA ${tva}%`, "", "", `${fmtDec(globalTTC)} ${sym}`]);

    doc.autoTable({
      startY: 38,
      head: [["Lot", "Base HT", showMarges ? "Honoraires YOMA" : "", "Total Client"]],
      body: recapRows, theme: "grid",
      headStyles: { fillColor: [28, 25, 21], textColor: [201, 169, 110], fontStyle: "bold" },
      bodyStyles: { fontSize: 10 },
      alternateRowStyles: { fillColor: [252, 249, 245] },
      columnStyles: { 1: { halign: "right" }, 2: { halign: "right" }, 3: { halign: "right", fontStyle: "bold" } },
      didParseCell: (data) => {
        if (data.row.index >= recapRows.length - (tva > 0 ? 2 : 1)) {
          data.cell.styles.fillColor = [248, 244, 238];
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fontSize  = 11;
        }
      },
      margin: { left: 14, right: 14 },
    });

    doc.setFont("helvetica", "normal"); doc.setFontSize(7); doc.setTextColor(170, 160, 150);
    doc.text("YOMA DESIGN · Estimatif Travaux · Document confidentiel", 14, H - 6);
    doc.text(today, W - 14, H - 6, { align: "right" });

    doc.save(`YOMA_Estimatif_${(project.name || "Projet").replace(/\s+/g, "_")}_${new Date().toLocaleDateString("fr-FR").replace(/\//g, "-")}.pdf`);
  }

  // ═══════════════════════════════════════════════════════════════════════════
  return (
    <div style={{ display: "flex", minHeight: "100vh", background: WARM, fontFamily: "'DM Sans', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=Playfair+Display:wght@600;700&display=swap');
        .est-input { background:${WHITE}; border:1px solid ${BORDER}; border-radius:6px; padding:7px 10px; font-size:13px; color:${INK}; font-family:'DM Sans',sans-serif; box-sizing:border-box; }
        .est-input:focus { outline:none; border-color:${GOLD}; }
        .est-btn { border:none; border-radius:7px; padding:9px 16px; cursor:pointer; font-size:13px; font-weight:600; transition:all .15s; font-family:'DM Sans',sans-serif; }
        .est-btn:hover:not(:disabled) { opacity:.85; transform:translateY(-1px); }
        .est-btn:disabled { opacity:.4; cursor:default; }
        .row-item:hover { background:#FAF8F5 !important; }
        .cell-inp { border:none; background:transparent; font-size:13px; color:${INK}; width:100%; padding:3px 4px; font-family:'DM Sans',sans-serif; }
        .cell-inp:focus { outline:1px solid ${GOLD}; border-radius:3px; background:${WHITE}; }
        .cell-inp::-webkit-inner-spin-button,.cell-inp::-webkit-outer-spin-button { opacity:0; }
        .lot-header { cursor:pointer; user-select:none; }
        .lot-header:hover { opacity:.9; }
        .inject-glow { box-shadow: 0 0 0 2px ${GOLD}, 0 0 12px rgba(201,169,110,.4) !important; }
      `}</style>

      {/* ── SIDEBAR ── */}
      <aside style={{ width: 230, background: INK, display: "flex", flexDirection: "column", padding: "20px 12px", flexShrink: 0, overflowY: "auto" }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 24, paddingBottom: 18, borderBottom: "1px solid rgba(255,255,255,.1)" }}>
          <div style={{ color: GOLD, fontFamily: "'Playfair Display',serif", fontSize: 18, fontWeight: 700, letterSpacing: 3 }}>YOMA</div>
          <div style={{ color: "#6A5D52", fontSize: 9, letterSpacing: "0.2em", marginTop: 3 }}>MÉTRÉ & ESTIMATIF</div>
        </div>

        {/* Projet */}
        <div style={{ marginBottom: 18 }}>
          <div style={{ color: "#6A5D52", fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", marginBottom: 8 }}>PROJET</div>
          {[["name", "Nom du projet"], ["client", "Client"], ["surface", "Surface m²"], ["adresse", "Adresse"]].map(([f, ph]) => (
            <input key={f} className="est-input" placeholder={ph} value={project[f]}
              onChange={e => setProject(p => ({ ...p, [f]: e.target.value }))}
              style={{ background: "rgba(255,255,255,.07)", border: "1px solid rgba(255,255,255,.1)", color: WHITE, width: "100%", marginBottom: 6 }} />
          ))}
        </div>

        {/* Devise + TVA */}
        <div style={{ marginBottom: 18 }}>
          <div style={{ color: "#6A5D52", fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", marginBottom: 8 }}>PARAMÈTRES</div>
          <div style={{ display: "flex", gap: 6, marginBottom: 6 }}>
            <select value={currency} onChange={e => setCurrency(e.target.value)}
              style={{ flex: 1, background: "rgba(255,255,255,.08)", border: "1px solid rgba(255,255,255,.15)", color: WHITE, borderRadius: 6, padding: "7px 8px", fontSize: 12, fontFamily: "'DM Sans',sans-serif" }}>
              {CURRENCIES.map(c => <option key={c.code} value={c.code} style={{ background: INK }}>{c.code}</option>)}
            </select>
            <div style={{ display: "flex", alignItems: "center", background: "rgba(255,255,255,.07)", border: "1px solid rgba(255,255,255,.1)", borderRadius: 6, padding: "0 8px", gap: 4 }}>
              <input type="number" value={tva} onChange={e => setTva(Number(e.target.value))} min={0} max={100}
                style={{ width: 34, background: "transparent", border: "none", color: WHITE, fontSize: 12, textAlign: "center", fontFamily: "'DM Sans',sans-serif" }} />
              <span style={{ color: "#6A5D52", fontSize: 11 }}>TVA%</span>
            </div>
          </div>
        </div>

        {/* Récap financier */}
        <div style={{ marginBottom: 18, padding: "14px", background: "rgba(255,255,255,.04)", borderRadius: 8, borderTop: "1px solid rgba(255,255,255,.08)" }}>
          <div style={{ color: "#6A5D52", fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", marginBottom: 10 }}>BUDGET GLOBAL</div>
          {lots.map(lot => {
            const lt = lotTotals(lot);
            if (lt.client === 0) return null;
            return (
              <div key={lot.id} style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                <span style={{ color: "#8A7B6D", fontSize: 11 }}>{lot.icon} {lot.id}</span>
                <span style={{ color: WHITE, fontSize: 11, fontWeight: 600 }}>{fmtN(lt.client, sym)}</span>
              </div>
            );
          })}
          <div style={{ borderTop: "1px solid rgba(255,255,255,.1)", marginTop: 8, paddingTop: 8 }}>
            <div style={{ color: GOLD, fontSize: 10, marginBottom: 2 }}>Total Client HT</div>
            <div style={{ color: WHITE, fontSize: 20, fontWeight: 700, fontFamily: "'Playfair Display',serif" }}>{fmtN(globalClient, sym)}</div>
            {tva > 0 && <div style={{ color: "#5A4E46", fontSize: 11, marginTop: 2 }}>TTC {tva}% : {fmtN(globalTTC, sym)}</div>}
            {showMarges && <div style={{ color: GOLD, fontSize: 11, marginTop: 4 }}>Honoraires YOMA : {fmtN(globalMarge, sym)}</div>}
          </div>
        </div>

        {/* Actions */}
        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: "auto" }}>
          <button className="est-btn" onClick={exportPDF} style={{ background: GOLD, color: INK }}>📄 Exporter PDF</button>
          <button className="est-btn" onClick={() => setShowMarges(m => !m)}
            style={{ background: "transparent", color: "#6A5D52", border: "1px solid rgba(255,255,255,.1)", fontSize: 12 }}>
            {showMarges ? "🔒 Masquer marges" : "👁 Voir marges"}
          </button>
          <button className="est-btn" onClick={() => { if (window.confirm("Remettre toutes les quantités à zéro ?")) setLots(JSON.parse(JSON.stringify(DEFAULT_LOTS))); }}
            style={{ background: "transparent", color: "#4A3E35", border: "1px solid rgba(255,255,255,.06)", fontSize: 11 }}>
            ↺ Réinitialiser
          </button>
        </div>
      </aside>

      {/* ── MAIN ── */}
      <main style={{ flex: 1, padding: "24px 28px", overflowY: "auto" }}>

        {/* Top bar */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, flexWrap: "wrap", gap: 12 }}>
          <div>
            <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 26, fontWeight: 700, color: INK }}>
              {project.name || "Nouveau Projet"}
            </div>
            <div style={{ color: MUTED, fontSize: 13, marginTop: 2 }}>
              {project.client && `Client : ${project.client}`}
              {project.surface && ` · ${project.surface} m²`}
            </div>
          </div>
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            {/* Canvas button */}
            <button className="est-btn" onClick={() => setShowCanvas(true)}
              style={{ background: INK, color: GOLD, border: `1px solid ${GOLD}` }}>
              📐 Mesure sur Plan
            </button>
            {pending && (
              <div style={{ background: "rgba(201,169,110,.15)", border: `1px solid ${GOLD}`, borderRadius: 8, padding: "8px 16px", display: "flex", gap: 12, alignItems: "center" }}>
                <span style={{ color: INK, fontWeight: 700, fontSize: 14 }}>📐 {pending.label}</span>
                <span style={{ color: MUTED, fontSize: 12 }}>→ Cliquez ↗ sur la ligne cible</span>
                <button onClick={() => setPending(null)} style={{ background: "none", border: "none", color: MUTED, cursor: "pointer", fontSize: 16 }}>✕</button>
              </div>
            )}
          </div>
        </div>

        {/* ── Bannière auto-fill ── */}
        {autoFilled && (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, padding: "10px 18px", marginBottom: 16, background: "rgba(39,174,96,0.08)", border: "1px solid rgba(39,174,96,0.25)", borderRadius: 10 }}>
            <div>
              <div style={{ color: "#27AE60", fontWeight: 700, fontSize: 13 }}>✓ Quantités calculées automatiquement depuis vos plans</div>
              <div style={{ color: MUTED, fontSize: 11, marginTop: 2 }}>Les cellules marquées <span style={{ background: "#27AE60", color: WHITE, borderRadius: 3, padding: "1px 5px", fontSize: 10 }}>AUTO</span> sont des estimations — ajustez si besoin</div>
            </div>
            <button onClick={() => setAutoFilled(false)} style={{ background: "none", border: "none", color: MUTED, cursor: "pointer", fontSize: 16 }}>✕</button>
          </div>
        )}

        {/* ── LOTS ── */}
        {lots.map(lot => {
          const lt = lotTotals(lot);
          const isOpen = openLots[lot.id];

          return (
            <div key={lot.id} style={{ marginBottom: 16, borderRadius: 14, border: `1px solid ${BORDER}`, overflow: "hidden", background: WHITE }}>
              {/* Lot header */}
              <div className="lot-header" onClick={() => setOpenLots(o => ({ ...o, [lot.id]: !isOpen }))}
                style={{ display: "flex", alignItems: "center", padding: "14px 20px", background: INK, justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <span style={{ fontSize: 20 }}>{lot.icon}</span>
                  <div>
                    <div style={{ color: WHITE, fontWeight: 700, fontSize: 15 }}>{lot.label}</div>
                    <div style={{ color: "#6A5D52", fontSize: 11, marginTop: 1 }}>
                      {lot.sous_lots.reduce((s, sl) => s + sl.items.filter(i => Number(i.quantite) > 0).length, 0)} postes renseignés
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
                  {lt.client > 0 && <>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ color: "#6A5D52", fontSize: 10 }}>HT</div>
                      <div style={{ color: "#BBA990", fontSize: 13 }}>{fmtN(lt.ht, sym)}</div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ color: GOLD, fontSize: 10 }}>CLIENT</div>
                      <div style={{ color: WHITE, fontSize: 16, fontWeight: 700 }}>{fmtN(lt.client, sym)}</div>
                    </div>
                  </>}
                  <span style={{ color: GOLD, fontSize: 18 }}>{isOpen ? "▲" : "▼"}</span>
                </div>
              </div>

              {/* Sous-lots */}
              {isOpen && (
                <div>
                  {lot.sous_lots.map(sl => {
                    const slKey = `${lot.id}-${sl.id}`;
                    const isSlOpen = openSLots[slKey] !== false; // default open
                    const slTotal = sl.items.reduce((s, it) => s + calcRow(it).client, 0);

                    return (
                      <div key={sl.id} style={{ borderTop: `1px solid ${BORDER}` }}>
                        {/* Sous-lot header */}
                        <div className="lot-header" onClick={() => setOpenSLots(o => ({ ...o, [slKey]: !isSlOpen }))}
                          style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 20px", background: SOFT }}>
                          <div style={{ color: INK, fontWeight: 600, fontSize: 13 }}>{sl.label}</div>
                          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                            {slTotal > 0 && <span style={{ color: MUTED, fontSize: 12, fontWeight: 600 }}>{fmtN(slTotal, sym)}</span>}
                            <button className="est-btn" onClick={e => { e.stopPropagation(); addItem(lot.id, sl.id); }}
                              style={{ background: "rgba(201,169,110,.15)", color: MUTED, padding: "4px 10px", fontSize: 12 }}>+ Ligne</button>
                            <span style={{ color: MUTED, fontSize: 14 }}>{isSlOpen ? "▲" : "▼"}</span>
                          </div>
                        </div>

                        {/* Table */}
                        {isSlOpen && (
                          <div style={{ overflowX: "auto" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                              <thead>
                                <tr style={{ background: "#F5F0EA", borderBottom: `1px solid ${BORDER}` }}>
                                  {["Désignation", "Unité", "Quantité", "Prix U.", "Total HT",
                                    ...(showMarges ? ["Marge %", "Total Client"] : []),
                                    ""].map((h, i) => (
                                    <th key={i} style={{ padding: "8px 10px", color: MUTED, fontWeight: 700, fontSize: 10, letterSpacing: "0.06em", textAlign: i >= 2 && i <= 6 ? "right" : "left", whiteSpace: "nowrap" }}>{h}</th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {sl.items.map((it, idx) => {
                                  const c = calcRow(it);
                                  const isTarget = injectRow === it.id;
                                  return (
                                    <tr key={it.id} className="row-item" style={{ background: idx % 2 === 0 ? WHITE : "#FDFBF8", borderBottom: `1px solid #F0EBE3` }}>
                                      <td style={{ padding: "6px 10px", minWidth: 220 }}>
                                        <input className="cell-inp" value={it.designation} onChange={e => updateItem(lot.id, sl.id, it.id, "designation", e.target.value)} />
                                      </td>
                                      <td style={{ padding: "6px 8px" }}>
                                        <select value={it.unite} onChange={e => updateItem(lot.id, sl.id, it.id, "unite", e.target.value)}
                                          style={{ border: `1px solid ${BORDER}`, borderRadius: 4, padding: "3px 6px", fontSize: 12, color: MUTED, background: WHITE }}>
                                          {["m²", "ml", "m³", "U", "Forfait", "kg"].map(u => <option key={u}>{u}</option>)}
                                        </select>
                                      </td>
                                      {/* Quantité + inject */}
                                      <td style={{ padding: "6px 8px", textAlign: "right" }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: 4, justifyContent: "flex-end" }}>
                                          {it._auto && (
                                            <span title="Calculé automatiquement depuis le plan" style={{ background: "#27AE60", color: WHITE, borderRadius: 3, padding: "1px 4px", fontSize: 9, fontWeight: 700, flexShrink: 0 }}>AUTO</span>
                                          )}
                                          <input type="number" min="0" step="0.01" className="cell-inp"
                                            value={it.quantite}
                                            onChange={e => updateItem(lot.id, sl.id, it.id, "quantite", e.target.value)}
                                            style={{ textAlign: "right", width: 70 }} />
                                          {pending && (
                                            <button title={`Injecter ${pending.label}`}
                                              onClick={() => injectMeasure(lot.id, sl.id, it.id, pending.value)}
                                              style={{ background: GOLD, color: INK, border: "none", borderRadius: 5, width: 24, height: 24, cursor: "pointer", fontSize: 13, lineHeight: 1, flexShrink: 0 }}>↗</button>
                                          )}
                                        </div>
                                      </td>
                                      <td style={{ padding: "6px 8px", textAlign: "right" }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: 3, justifyContent: "flex-end" }}>
                                          <input type="number" min="0" step="0.01" className="cell-inp"
                                            value={it.prixU} onChange={e => updateItem(lot.id, sl.id, it.id, "prixU", e.target.value)}
                                            style={{ textAlign: "right", width: 80 }} />
                                          <span style={{ fontSize: 11, color: MUTED }}>{sym}</span>
                                        </div>
                                      </td>
                                      <td style={{ padding: "6px 10px", textAlign: "right", color: MUTED, fontWeight: 600 }}>
                                        {c.ht > 0 ? fmtN(c.ht, sym) : <span style={{ color: "#DDD" }}>—</span>}
                                      </td>
                                      {showMarges && <>
                                        <td style={{ padding: "6px 8px", textAlign: "right" }}>
                                          <div style={{ display: "flex", alignItems: "center", gap: 3, justifyContent: "flex-end" }}>
                                            <input type="number" min="0" max="100" className="cell-inp"
                                              value={it.marge} onChange={e => updateItem(lot.id, sl.id, it.id, "marge", e.target.value)}
                                              style={{ textAlign: "right", width: 40 }} />
                                            <span style={{ fontSize: 11, color: MUTED }}>%</span>
                                          </div>
                                        </td>
                                        <td style={{ padding: "6px 10px", textAlign: "right", fontWeight: 700, color: INK }}>
                                          {c.client > 0 ? fmtN(c.client, sym) : <span style={{ color: "#DDD" }}>—</span>}
                                        </td>
                                      </>}
                                      <td style={{ padding: "6px 8px", textAlign: "center" }}>
                                        <button onClick={() => delItem(lot.id, sl.id, it.id)}
                                          style={{ background: "none", border: "none", cursor: "pointer", color: "#CCC", fontSize: 14 }}>🗑</button>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>

                            {/* Sous-total sous-lot */}
                            {slTotal > 0 && (
                              <div style={{ display: "flex", justifyContent: "flex-end", padding: "8px 18px", background: SOFT, borderTop: `1px solid ${BORDER}`, gap: 32 }}>
                                <div style={{ textAlign: "right" }}>
                                  <div style={{ fontSize: 11, color: MUTED }}>Base HT</div>
                                  <div style={{ fontSize: 14, fontWeight: 600, color: MUTED }}>{fmtN(sl.items.reduce((s, it) => s + calcRow(it).ht, 0), sym)}</div>
                                </div>
                                {showMarges && (
                                  <div style={{ textAlign: "right" }}>
                                    <div style={{ fontSize: 11, color: MUTED }}>Honoraires</div>
                                    <div style={{ fontSize: 14, fontWeight: 600, color: GOLD }}>{fmtN(sl.items.reduce((s, it) => s + calcRow(it).margeAmt, 0), sym)}</div>
                                  </div>
                                )}
                                <div style={{ textAlign: "right" }}>
                                  <div style={{ fontSize: 11, color: MUTED }}>Total {sl.label}</div>
                                  <div style={{ fontSize: 18, fontWeight: 700, color: INK }}>{fmtN(slTotal, sym)}</div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}

        {/* ── RÉCAP GLOBAL ── */}
        <div style={{ background: INK, borderRadius: 14, padding: "20px 24px", marginTop: 8 }}>
          <div style={{ color: GOLD, fontWeight: 700, fontSize: 14, marginBottom: 16 }}>RÉCAPITULATIF GLOBAL</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 16 }}>
            {lots.map(lot => {
              const lt = lotTotals(lot);
              return lt.client > 0 ? (
                <div key={lot.id} style={{ background: "rgba(255,255,255,.04)", borderRadius: 8, padding: 14 }}>
                  <div style={{ color: "#6A5D52", fontSize: 11 }}>{lot.icon} {lot.label.split("—")[1]?.trim()}</div>
                  <div style={{ color: WHITE, fontSize: 16, fontWeight: 700, marginTop: 4 }}>{fmtN(lt.client, sym)}</div>
                </div>
              ) : null;
            })}
            <div style={{ background: "rgba(201,169,110,.15)", border: `1px solid ${GOLD}`, borderRadius: 8, padding: 14 }}>
              <div style={{ color: GOLD, fontSize: 11, fontWeight: 700 }}>TOTAL CLIENT HT</div>
              <div style={{ color: WHITE, fontSize: 20, fontWeight: 700, marginTop: 4 }}>{fmtN(globalClient, sym)}</div>
              {tva > 0 && <div style={{ color: "#6A5D52", fontSize: 11, marginTop: 3 }}>TTC : {fmtN(globalTTC, sym)}</div>}
            </div>
            {showMarges && globalMarge > 0 && (
              <div style={{ background: "rgba(201,169,110,.08)", borderRadius: 8, padding: 14 }}>
                <div style={{ color: GOLD, fontSize: 11 }}>HONORAIRES YOMA</div>
                <div style={{ color: GOLD, fontSize: 20, fontWeight: 700, marginTop: 4 }}>{fmtN(globalMarge, sym)}</div>
                <div style={{ color: "#6A5D52", fontSize: 11, marginTop: 2 }}>{((globalMarge / globalClient) * 100).toFixed(1)}% du budget</div>
              </div>
            )}
          </div>
        </div>
      </main>

      {/* ── CANVAS MODAL ── */}
      {showCanvas && (
        <CanvasMeasure
          onMeasure={(m) => { setPending(m); setShowCanvas(false); }}
          onAutoCalc={(data) => { autoFillFromMeasures(data); setShowCanvas(false); }}
          onClose={() => setShowCanvas(false)}
        />
      )}
    </div>
  );
}
